<div class="ri" *ngIf="content as c">
  <!-- ── Вступление ─────────────────────────────────────────────────────── -->
  <section class="ri-hero">
    <div class="ri-ic" aria-hidden="true">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </div>
    <span class="ri-tag">{{ c.tag }}</span>
    <h1>{{ c.title }}</h1>
    <p class="ri-lead">{{ c.lead }}</p>
    <p class="ri-text">{{ c.text }}</p>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </section>

  <!-- ── Что вы получаете ───────────────────────────────────────────────── -->
  <section class="ri-section">
    <h2>{{ common['benefitsTitle'] }}</h2>
    <div class="ri-benefits">
      <div class="ri-benefit" *ngFor="let b of c.benefits">
        <span class="ri-check" aria-hidden="true">✓</span>
        <h3>{{ b.title }}</h3>
        <p>{{ b.text }}</p>
      </div>
    </div>
  </section>

  <!-- ── Как это работает ───────────────────────────────────────────────── -->
  <section class="ri-section">
    <h2>{{ common['stepsTitle'] }}</h2>
    <ol class="ri-steps" [class.ri-steps--3]="c.steps.length === 3">
      <li *ngFor="let s of c.steps; let i = index">
        <span class="ri-num">{{ i + 1 }}</span>
        <h3>{{ s.title }}</h3>
        <p>{{ s.text }}</p>
      </li>
    </ol>
  </section>

  <!-- ── Стоимость (только у грузовладельца) ────────────────────────────── -->
  <section class="ri-section" *ngIf="c.pricing?.length">
    <h2>{{ common['pricingTitle'] }}</h2>
    <div class="ri-prices">
      <div class="ri-price" *ngFor="let p of c.pricing" [class.ri-price--hl]="p.highlight">
        <h3>{{ p.title }}</h3>
        <p class="ri-price__value">{{ p.price }} <small *ngIf="p.unit">{{ p.unit }}</small></p>
        <p class="ri-price__text">{{ p.text }}</p>
      </div>
    </div>
    <p class="ri-note" *ngIf="c.pricingNote">{{ c.pricingNote }}</p>
    <a class="ri-more" href="/#tar" (click)="goToTariffs($event)">{{ common['pricingMore'] }} →</a>
  </section>

  <!-- ── Частые вопросы ─────────────────────────────────────────────────── -->
  <section class="ri-section ri-section--narrow">
    <h2>{{ common['faqTitle'] }}</h2>
    <div class="ri-faq">
      <details *ngFor="let f of c.faq">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
    </div>
  </section>

  <!-- ── Призыв ─────────────────────────────────────────────────────────── -->
  <section class="ri-cta">
    <h2>{{ c.ctaTitle }}</h2>
    <p>{{ c.ctaText }}</p>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </section>
</div>

<!-- Кнопки: регистрация (+ бесплатный расчёт у грузовладельца) или WhatsApp у брокера -->
<ng-template #actions>
  <div class="ri-actions">
    <div class="ri-buttons">
      <a *ngIf="registrationRoute" class="ri-btn" [routerLink]="registrationRoute">{{ common['register'] }}</a>
      <a *ngIf="role === 'cargoOwner'" class="ri-btn ri-btn--ghost" routerLink="/calculations/new">{{ common['calculate'] }}</a>
      <a *ngIf="!registrationRoute" class="ri-btn ri-btn--whatsapp" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.39 1.26 4.82L2 22l5.4-1.42a9.9 9.9 0 0 0 4.64 1.18h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.1c-.24.68-1.4 1.3-1.93 1.38-.49.08-1.11.11-1.79-.11-.41-.13-.94-.3-1.62-.6-2.86-1.24-4.72-4.12-4.86-4.31-.14-.19-1.16-1.54-1.16-2.94 0-1.4.73-2.08.99-2.37.26-.28.57-.35.76-.35.19 0 .38 0 .55.01.17.01.41-.07.64.49.24.58.81 2 .88 2.14.07.14.12.31.02.5-.1.19-.15.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.57.17.28.74 1.22 1.58 1.98 1.09.97 2 1.27 2.29 1.41.29.14.46.12.63-.07.17-.19.72-.84.92-1.13.19-.28.38-.24.64-.14.26.1 1.67.79 1.95.93.29.14.48.21.55.33.07.12.07.68-.17 1.36z"/></svg>
        {{ common['whatsapp'] }}
      </a>
    </div>
    <a *ngIf="registrationRoute" class="ri-login" routerLink="/login">{{ common['hasAccount'] }}</a>
  </div>
</ng-template>

<ng-template #icon>
  <ng-container [ngSwitch]="role">
    <svg *ngSwitchCase="'cargoOwner'" viewBox="0 0 48 48"><defs><linearGradient id="riBoxB" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5DB8FF"/><stop offset="1" stop-color="#087CF4"/></linearGradient><linearGradient id="riBoxD" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#1F5BC0"/><stop offset="1" stop-color="#001F5C"/></linearGradient></defs><path d="M24 4l18 9-18 9-18-9z" fill="#7CC4FF"/><path d="M6 13l18 9v22L6 35z" fill="url(#riBoxB)"/><path d="M42 13v22l-18 9V22z" fill="url(#riBoxD)"/><path d="M15 8.5l18 9v6" fill="none" stroke="#fff" stroke-opacity=".7" stroke-width="3" stroke-linejoin="round"/></svg>
    <svg *ngSwitchCase="'freightForwarder'" viewBox="0 0 48 48"><defs><linearGradient id="riTruckB" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5DB8FF"/><stop offset="1" stop-color="#087CF4"/></linearGradient><linearGradient id="riTruckD" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#1F5BC0"/><stop offset="1" stop-color="#001F5C"/></linearGradient></defs><rect x="3" y="11" width="26" height="22" rx="3.5" fill="url(#riTruckB)"/><rect x="3" y="11" width="26" height="6" rx="3" fill="#fff" opacity=".25"/><path d="M29 18h9l7 8v7H29z" fill="url(#riTruckD)"/><path d="M33 21h4l4 5h-8z" fill="#BFE3FF"/><rect x="3" y="31" width="42" height="3" rx="1.5" fill="#001F5C"/><circle cx="13" cy="36" r="5.5" fill="#001F5C"/><circle cx="13" cy="36" r="2.2" fill="#fff"/><circle cx="36" cy="36" r="5.5" fill="#001F5C"/><circle cx="36" cy="36" r="2.2" fill="#fff"/></svg>
    <svg *ngSwitchCase="'customsBroker'" viewBox="0 0 48 48"><defs><linearGradient id="riDocB" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5DB8FF"/><stop offset="1" stop-color="#087CF4"/></linearGradient><linearGradient id="riDocD" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#1F5BC0"/><stop offset="1" stop-color="#001F5C"/></linearGradient></defs><path d="M11 4h18l11 11v27a3 3 0 01-3 3H11a3 3 0 01-3-3V7a3 3 0 013-3z" fill="url(#riDocB)"/><path d="M29 4v8a3 3 0 003 3h8z" fill="url(#riDocD)" opacity=".55"/><g fill="#fff"><rect x="14" y="22" width="20" height="3" rx="1.5"/><rect x="14" y="29" width="20" height="3" rx="1.5" opacity=".85"/><rect x="14" y="36" width="12" height="3" rx="1.5" opacity=".7"/></g></svg>
    <svg *ngSwitchCase="'supplier'" viewBox="0 0 48 48"><defs><linearGradient id="riFactoryB" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5DB8FF"/><stop offset="1" stop-color="#087CF4"/></linearGradient><linearGradient id="riFactoryD" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#1F5BC0"/><stop offset="1" stop-color="#001F5C"/></linearGradient></defs><rect x="37" y="6" width="5" height="14" rx="1.5" fill="url(#riFactoryD)"/><circle cx="39.5" cy="3.5" r="2.5" fill="#BFE3FF"/><path d="M4 44V22l10 6v-6l10 6v-6l10 6V18h10v26z" fill="url(#riFactoryB)"/><path d="M4 22l10 6v-6l10 6v-6l10 6V18h10v4H34v6l-10-6v6l-10-6v6L4 26z" fill="#fff" opacity=".28"/><g fill="#fff"><rect x="7" y="32" width="5" height="5" rx="1.4"/><rect x="17" y="32" width="5" height="5" rx="1.4"/><rect x="27" y="32" width="5" height="5" rx="1.4"/></g><rect x="36" y="32" width="6" height="12" rx="1.5" fill="url(#riFactoryD)"/><rect x="2" y="43" width="44" height="2.5" rx="1.2" fill="#001F5C" opacity=".35"/></svg>
  </ng-container>
</ng-template>
